import CacheUtil from "../../../../../shared/lib/html5-software-library/src/ranj/util/CacheUtil";
import AppModel from "../../../../../shared/src/ranj/app/core/AppModel";
import AbstractView from "../../../../../shared/src/ranj/equalture/view/AbstractView";

export default class LocationView extends AbstractView {

    constructor(target) {
        super(target);
        storeOriginalDisplayProps(target);
        this._slots = [];
        for (let i = 0; i < 999; i++) {
            const slot = target["slot" + i];
            if (!slot) {
                break;
            }
            storeOriginalDisplayProps(slot);
            this._slots.push(slot);
        }
    }

    getSlot(index) {
        return this._slots[index];
    }

    get target() {
        return this._target;
    }

    reset() {
        restoreOriginalDisplayProps(this._target);
        this._slots.forEach(slot => restoreOriginalDisplayProps(slot));
    }
};
    
const storeOriginalDisplayProps = function(obj) {
    obj.orig = { alpha: obj.alpha, y: obj.y, x: obj.x, scaleX: obj.scaleX, scaleY: obj.scaleY };
}
const restoreOriginalDisplayProps = function(obj) {
    Object.keys(obj.orig).forEach(key => obj[key] = obj.orig[key]);
}